import { PlusIcon } from '@heroicons/react/24/solid';
import React, { MouseEventHandler } from 'react';

interface AddNewBriefBtnProps {
  onClick?: MouseEventHandler;
}

export function AddNewBriefBtn(props: AddNewBriefBtnProps) {
  return (
    <button
      type="button"
      className="order-0 w-full flex justify-center px-4 py-2 border border-transparent shadow-xs text-sm font-medium rounded-md text-white bg-secondary hover:bg-secondary-dark hover:text-white hover:no-underline focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-secondary"
      onClick={props.onClick}
    >
      <PlusIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" /> Add New Brief
    </button>
  );
}
